import { make } from 'vuex-pathify'
import { validDistricts } from '../../common/validDistricts'
import { districts } from '../../common/districts'

const state = {
  user: {},
  districtId: null
}

const mutations = {
  ...make.mutations(state),
  SET_DEFAULT_DISTRICT(state, payload) {
    if (validDistricts.includes(payload)) {
      state.districtId = payload
      window.localStorage.setItem('commando_mobile_district_id', payload)
    } else {
      if (
        !validDistricts.includes(payload) &&
        [...new Set((state.user?.access || []).flatMap(x => x.d))].includes(
          payload
        )
      ) {
        state.districtId = payload
        window.localStorage.setItem('commando_mobile_district_id', payload)
      } else {
        state.districtId = null
        window.localStorage.removeItem('commando_mobile_district_id')
      }
    }
  }
}

export const store = {
  namespaced: true,
  state,
  mutations,
  getters: {
    districts(state) {
      console.log(state.user)
      return [...new Set((state.user?.access || []).flatMap(x => x.d))]
        .filter(x => validDistricts.includes(x))
        .map(x => ({
          districtId: x,
          districtName: districts.find(d => d.districtId === x).districtName
        }))
    }
  }
}
